import React from 'react';
import CONFIG from '../../../Config';

class InputMulti extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      buttons: props.buttons,
      payloads: props.payloads,
      buttonsData: props.buttonsData,
      buttonSubmitHandler: props.buttonSubmitHandler,
      checks: props.buttons instanceof Array ? 
        props.buttons.map(b => false) :
        Object.keys(props.buttons).map(b => false),
      search_filter: '',
      filter_results: props.buttons instanceof Array ? 
        props.buttons.map(b => b.toLowerCase()) :
        Object.keys(props.buttons).map(b => props.buttons[b].toLowerCase()),
    };
    this.checksContainer = null;
    this.submitButton = null;
  }

  clickHandler(index) {
    const { buttons } = this.props;
    const checks = this.state.checks.slice();
    checks[index] = !checks[index];
    this.setState({
      checks: checks,
    });
  }

  submitHandler() {
    const { buttons, payloads } = this.props;
    const { checks } = this.state;
    const _buttons = buttons instanceof Array ? 
      buttons :
      Object.keys(buttons).map(b => buttons[b]);
    let _payloads = null;
    if (payloads)
      _payloads = payloads instanceof Array ? 
        payloads :
        Object.keys(payloads).map(b => payloads[b]);
    else
      _payloads = buttons instanceof Array ? 
        buttons :
        Object.keys(buttons).map(b => buttons[b]);
    this.props.buttonSubmitHandler(
      _buttons.filter((c, i) => checks[i]).join(', '),
      _payloads.filter((c, i) => checks[i]).join(', '),
    );
  }

  onSearchInput(e) {
    this.setState({
      search_filter: e.target.value,
      filter_results: this.getMatches(e.target.value),
    });
  }

  getMatches(value) {
    const { buttons } = this.props;
    const _buttons = buttons instanceof Array ? 
      buttons.map(b => b.toLowerCase()) :
      Object.keys(buttons).map(b => buttons[b].toLowerCase());
    const matches = _buttons
      .filter((b) => b.indexOf(value.toLowerCase()) > -1);
    return matches;
  }

  render() {
    const { buttons, buttonsData } = this.props;
    const { checks, search_filter, filter_results } = this.state;
    const { search } = buttonsData;
    const _buttons = buttons instanceof Array ? 
      buttons :
      Object.keys(buttons).map(b => buttons[b]);
    const disabled = checks.every(c => !c);

    const inputFooter = (
      <div className="hu-input-multi-footer hu-a-center">
        <button
          className="submit-button hu-background-color_button-background hu-color_button-text hu-border-color_button-text"
          onClick={this.submitHandler.bind(this)} 
          ref={(elem) => {this.submitButton = elem;}}
          disabled={disabled}
        >
          <span className="submit-text">{ CONFIG.text.send }</span>
          <span className="right-arrow">
            <svg className="hu-fill_button-text" xmlns="http://www.w3.org/2000/svg">
              <path d="M 11.78125 2.28125 L 2.78125 11.28125 L 2.09375 12 L 2.78125 12.71875 L 11.78125 21.71875 L 13.21875 20.28125 L 5.9375 13 L 22 13 L 22 11 L 5.9375 11 L 13.21875 3.71875 Z "></path>
            </svg>
          </span>
          {/* <i className="fi right-arrow"></i> */}
        </button>
      </div>
    );

    if (!search)
      return (
        <div className="hu-input-multi">
          <span className="hu-input-multi-info not-selectable hu-s-10 hu-color_contrast hu-t-uppercase">{ CONFIG.text.input_multi_help }</span>
          <div className="hu-buttons-container">
            <div className="hu-input-multi-buttons" ref={(elem) => {this.checksContainer = elem;}}>
              { _buttons.map((key, index) => 
                <div 
                  className={`multi-button hu-color_button-text hu-background-color_button-background hu-border-color_button-background-dark${checks[index] ? ' active' : ''}`}
                  data-key={index}
                  onClick={() => {this.clickHandler(index)}}
                >
                  <div className="check-block">
                    <input className="check-input" type="checkbox" data-key={index} checked={checks[index]} />
                    <label className="check-label"></label>
                  </div>
                  <span className="button-text">{key}</span>
                </div>
              )}
            </div>
          </div>
          {inputFooter}
        </div>
      );
    else
      return (
        <div className="hu-input-multi">
          <span className="hu-input-multi-info not-selectable hu-s-10 hu-color_contrast hu-t-uppercase">{ CONFIG.text.input_instant_search_help }</span>
          <div className="hu-drop-search">
            <div className="drop-search-input-container">
              <input
                className="drop-search-input hu-color_contrast hu-s-14"
                type="text"
                placeholder={CONFIG.text.search}
                value={search_filter}
                onInput={(e) => this.onSearchInput(e)}
              />
              <i className="fi magnification-lens hu-color_contrast"></i>
            </div>
            <div className="hu-buttons-container">
              <div className="hu-input-multi-buttons" ref={(elem) => {this.checksContainer = elem;}}>
                { _buttons.map((key, index) => {
                  return ( (filter_results.indexOf(key.toLowerCase()) > -1 || checks[index]) &&
                    <div 
                      className={`multi-button hu-color_button-text hu-background-color_button-background hu-border-color_button-background-dark${checks[index] ? ' active' : ''}`}
                      data-key={index}
                      onClick={() => {this.clickHandler(index)}}
                    >
                      <div className="check-block">
                        <input className="check-input" type="checkbox" data-key={index} checked={checks[index]} />
                        <label className="check-label"></label>
                      </div>
                      <span className="button-text">{key}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {inputFooter}
        </div>
      );
  }
}

export default InputMulti;


// WEBPACK FOOTER //
// ./app/js/components/messenger/input/InputMulti.js